(function (exports) {
  'use strict';

  const rejson = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/;

  function isNumber(num) {
    var number = +num;

    if ((number - number) !== 0) {
      // Discard Infinity and NaN
      return false;
    }

    if (number === num) {
      return true;
    }

    if (typeof num === 'string') {
      // String parsed, both a non-empty whitespace string and an empty string
      // will have been coerced to 0. If 0 trim the string and see if its empty.
      if (number === 0 && num.trim() === '') {
        return false;
      }
      return true;
    }
    return false;
  }
  function hyphenToCamelCase(hyphen) {
    return hyphen.replace(/-([a-z])/g, function(match) {
      return match[1].toUpperCase();
    });
  }

  function stringToCamelCase(string) {
    return string.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }


  class Parser {
    static parse(dataset, _prefixes = []) {
      let result = {};
      const keys = Object.keys(dataset);
      const grouping = _prefixes.length;
      const prefixes = _prefixes.map(hyphenToCamelCase);

      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let value = dataset[key];

        if (value === 'true') {
          result[key] = true;
          continue;
        }

        if (value === 'false') {
          result[key] = false;
          continue;
        }

        if (isNumber(value)) {
          result[key] = Number(value);
          continue;
        }

        if (value === 'null') {
          result[key] = null;
          continue;
        }

        if (rejson.test(value)) {
          result[key] = JSON.parse(value);
          continue;
        }

        // @String
        result[key] = value;
      }

      // Group result object
      prefixes.forEach(prefix => {
        let subResult = {};

        Object.keys(result)
          .filter(key => key.startsWith(prefix))
          .forEach(key => {
            let slicedKey = stringToCamelCase(key.replace(prefix, ''));
            if (slicedKey === '') slicedKey = prefix;
            subResult[slicedKey] = result[key];
            delete result[key];
          });

        result[prefix] = subResult;
      });

      return result;
    }
  }

  const defaults = {
    maxPages: 10, // maximum total pages => example 100
    maxVisiblePages: 10, // maximum visible pages => example 10
    pageSize: 10, // maximum items per page
    totalItems: 0, // total items count on all pages
    showNextAndPrev: true,
    nextText: 'Next',
    prevText: 'Previous',
    pageURI: '', // example => "search", '/search', etc
    pageQueryKey: 'page',
    preserveQueryParams: true, // preserve current query params from current url in pager links
    wrapperClass: 'TK-Pager',
    nextWrapperClass: 'TK-Pager-Next',
    nextLinkClass: 'TK-Pager-Next-Link',
    prevWrapperClass: 'TK-Pager-Prev',
    prevLinkClass: 'TK-Pager-Prev-Link',
    pagesWrapperClass: 'TK-Pager-Links',
    pageLinkClass: 'TK-Pager-Link',
    callback: (instance, selectedPage) => console.log(selectedPage)
  };

  class Pager {
    constructor(element, options) {
      if (!(element instanceof HTMLElement)) {
        throw new Error('[Pager] DOM element is required for initialization');
      }

      this.wrapper = element;

      let dataset = Parser.parse(element.dataset, ['pager']);

      this.options = { ...defaults, ...dataset.pager, ...options };

      this._maxPages = Math.round(Number(this.options.maxPages));
      this._maxVisiblePages = Math.round(Number(this.options.maxVisiblePages));
      this._pageSize = Math.round(Number(this.options.pageSize));
      this._totalItems = Math.round(Number(this.options.totalItems));

      this._current = 1;

      this.wrapper.classList.add(this.options.wrapperClass);
      this.wrapper.addEventListener('click', this._delegatedPageClick.bind(this), false);
    }

    getActivePage() {
      return this._current;
    }

    setPage(page = 1) {
      this._current = Math.floor(Number(page));
      return this;
    }

    setMaxPages(n) {
      this._maxPages = Math.round(Number(n));
      return this;
    }

    setPageSize(n) {
      this._pageSize = Math.round(Number(n));
      return this;
    }

    setTotalItems(n) {
      this._totalItems = Math.round(Number(n));
      return this;
    }

    setMaxVisiblePages(n) {
      this._maxVisiblePages = Math.round(Number(n));
      return this;
    }

    calcTotalPages() {
      const { _pageSize, _totalItems } = this;
      let pages = Math.floor(_totalItems / _pageSize);

      if (_totalItems % _pageSize > 0) {
        pages++;
      }

      return Math.min(pages, this._maxPages);
    }

    calcAndSetTotalPages() {
      // this._maxPages = this.calcTotalPages();
      this._totalPages = this.calcTotalPages();
      return this;
    }

    hasPrev() {
      return this._current !== 1;
    }

    hasNext() {
      if (this._totalPages < this._maxPages) {
        return this._current < this._totalPages;
      }
      return this._current < this._maxPages;
    }

    getPageInterval(page = 1) {
      const index = this.getPageIntervalIndex(page);

      let interval = Array.from(Array(this._maxVisiblePages))
        .fill(index * this._maxVisiblePages)
        .map((n, i) => (n + i + 1));

      const lastPageIndex = interval.indexOf(this._totalPages);

      if (lastPageIndex >= 0) {
        interval.splice(lastPageIndex + 1);
      }

      return interval;
    }

    getPageIntervalIndex(page = 1) {
      return Math.floor((page - 1) / this._maxVisiblePages);
    }


    _html() {
      const { prevText, nextText, pageURI, pageQueryKey, preserveQueryParams, prevWrapperClass, nextWrapperClass, pagesWrapperClass, prevLinkClass, nextLinkClass, pageLinkClass } = this.options;

      const url = new URL(window.location.href);
      url.searchParams.delete(pageQueryKey);

      const page = preserveQueryParams && url.search ? `${pageURI}${url.search}&${pageQueryKey}` : `${pageURI}?${pageQueryKey}`;
      const interval = this.getPageInterval(this._current);

      const prevArrow = `<svg viewBox="0 0 250 219" width="10" height="9" fill="currentColor" aria-hidden="true"><path d="m109.3 218.5l19.7-19.8-75.4-75.5 196.3 0.1v-28.1h-196.3l75.5-75.4-19.8-19.8-109.3 109.2 109.3 109.3z"/></svg>`;
      const nextArrow = `<svg viewBox="0 0 250 219" width="10" height="9" fill="currentColor" aria-hidden="true"><path d="m140.6 0l-19.8 19.8 75.5 75.5h-196.3v28h196.3l-75.5 75.4 19.8 19.8 109.3-109.3-109.3-109.2z"/></svg>`;

      const prev = `<div class="${prevWrapperClass}"><a href="${page}=${this._current - 1}" class="${prevLinkClass}" data-page="${this._current - 1}" aria-label="${prevText} page">${prevArrow}&ensp;${prevText}</a></div>`;
      const next = `<div class="${nextWrapperClass}"><a href="${page}=${this._current + 1}" class="${nextLinkClass}" data-page="${this._current + 1}" aria-label="${nextText} page">${nextText}&ensp;${nextArrow}</a></div>`;

      const links = interval.map(n => n === this._current ?
        `<a href="${page}=${n}" data-page="${n}" aria-label="page ${n}" class="${pageLinkClass} is-active">${n}</a>` :
        `<a href="${page}=${n}" data-page="${n}" aria-label="page ${n}" class="${pageLinkClass}">${n}</a>`
        ).join('');

      let html = '';

      // if (this.hasPrev()) {
        html += prev;
      // };

      html += `<div class="${pagesWrapperClass}">${links}</div>`;

      // if (this.hasNext()) {
        html += next;
      // };

      return html;
    }

    empty() {
      this.wrapper.innerHTML = '';
    }

    render() {
      this.calcAndSetTotalPages();
      this.wrapper.innerHTML = this._html();
      this.wrapper.classList.toggle('TK-Pager--Has-Prev', this.hasPrev());
      this.wrapper.classList.toggle('TK-Pager--Has-Next', this.hasNext());
    }

    _delegatedPageClick(event) {
      const { target } = event;
      const match = target.nodeName.toLowerCase() === 'a' && Boolean(target.dataset.page);

      if (!match) return;

      event.preventDefault();

      const { callback } = this.options;
      const page = Number(target.dataset.page);

      if (typeof callback === 'function') {
        callback(this, page);
      }
    }
  }

  const defaults$1 = {
    key: '',
    value: '',
    display: '',
    tagClass: 'TK-Tag', /* css class for the tag */
    tagCloseClass: 'TK-Tag-X', /* css class for the close button in tag */
  };

  class Tag {
    constructor(options) {
      const { key, value, display } = options;

      if (!key) {
        throw new Error('[Tag] key is required');
      }

      if (!value) {
        throw new Error('[Tag] value is required');
      }

      if (!display) {
        throw new Error('[Tag] display name is required')
      }

      this.options = { ...defaults$1, ...options };

      this.key = key.trim(); // Key and value should be stored in its original form, otherwise the query does not work
      this.value = value.trim();
      this.display = display.trim();

      this.element = this.render();
    }

    render() {
      const { key, value, display } = this.valueOf();

      const span = document.createElement('span');
      const close = document.createElement('span');

      close.innerHTML = `✖`;
      close.dataset ? close.dataset.role = 'remove' : close.setAttribute('data-role', 'remove');
      close.classList.add(this.options.tagCloseClass);

      span.innerText = display;
      span.append(close);

      if (span.dataset) {
        span.dataset.key = key;
        span.dataset.value = value;
        span.dataset.display = display;
      }
      else {
        span.setAttribute('data-key', key);
        span.setAttribute('data-value', value);
        span.setAttribute('data-display', display);
      }

      span.classList.add(this.options.tagClass);

      return span;
    }

    valueOf() {
      return {
        key: this.key,
        value: this.value,
        display: this.display
      }
    }

    static validate(options) {
      const { key, value, display } = options;

      if (!key) {
        throw new Error('[Tag] key is required');
      }

      if (!value) {
        throw new Error('[Tag] value is required');
      }

      if (!display) {
        throw new Error('[Tag] display name is required')
      }
    }

    static create(options = defaults$1) {
      return new Tag(options);
    }
  }

  const strip = (html = '') => new DOMParser().parseFromString(html, 'text/html').body.textContent.trim();
  const escape = (html = '') => html ? document.createElement('div').appendChild(document.createTextNode(html)).parentNode.innerHTML : html;
  const unescape = (html = '') => html ? new DOMParser().parseFromString(html, 'text/html').documentElement.textContent : html;

  const defaults$2 = {
    /*
     * Array of Tags for initial tags
     * Tag { key: String, value: String, display: String }
     */
    tags: [],

    /*
     * Input properties
     * If prefill is true it will prefill the input with the value from the query parameter
     */
    prefill: true,
    maxlength: 200, /* Max length for input */
    autofocus: false, /* Auto focus the input on initialization */
    placeholder: 'Looking for...', /* Placeholder for the input */

    /*
     * CSS Classes For Styling
     */
    tagClass: 'TK-Tag', /* css class for the tag */
    tagCloseClass: 'TK-Tag-X', /* css class for the close button in tag */
    tagsWrapperClass: 'TK-Tags-Wrapper', /* css class for div wrapping the tags */
    mainWrapperClass: 'TK-Tag-Input-Wrapper', /* css class for main wrapper, wraps all dom elements associated with this plugin */
    mainWrapperFocusClass: 'is-focus', /* css class to add when input is focused, class is added to the main wrapper */
    flexWrapperClass: 'TK-Tag-Input-Flex-Wrapper', /* css class for wrapper, wraps tags and input field */
    inputClass: 'TK-Tag-Input', /* css class for the input element */

    /*
     * Optional button to use
     */
    button: true, /* id selector to find associated button with the tag input */
    buttonText: '',
    buttonIcon: true,
    buttonIconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" aria-label="Search icon" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>', /* add custom html for the button */
    buttonClass: 'TK-Tag-Input-Button', /* css class to add to the button */

    /*
     * User provided callback executed on enter press or button click
     * The callback is called with TagInput instance as first agrument
     */
    callback: (instance) => console.log(instance.valueOf())
  };


  const KEYS = {
    ENTER: 13,
    ESCAPE: 27,
    BACKSPACE: 8
  };


  class TagInput {
    constructor(input, options) {
      if (!input) {
        throw new Error('[TagInput] Input element is required for initialization');
      }

      if (input.nodeName.toLowerCase() !== 'input') {
        throw new Error('[TagInput] TagInput should be initialized with `input` element');
      }

      this.input = input;
      this.options = { ...defaults$2, ...options };

      this.tags = new Map();
      this._state = new Map();

      this.options.tags.map(t => this.tags.set(t.display, Tag.create(t)));

      this.wrapper = document.createElement('div');
      this.flexWrapper = document.createElement('div');
      this.tagsWrapper = document.createElement('div');

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.ariaLabel = 'Click to search';

      if (this.options.buttonIcon) {
        this.button.innerHTML = this.options.buttonIconSvg;
      }

      if (this.options.buttonText) {
        this.button.innerHTML += `<span>${this.options.buttonText}</span>`;
      }

      /** @Handle initial options **/
      /** ========================================== **/
      if (this.options.placeholder) {
        this.input.placeholder = this.options.placeholder;
      }

      if (this.options.maxlength && parseInt(this.options.maxlength)) {
        this.input.maxLength = parseInt(this.options.maxlength);
      }

      if (this.options.autofocus) {
        this.input.focus();
        this.input.autofocus = true;
      }

      if (this.options.prefill) {
        this.prefill();
      }

      /** @Init **/
      /** ========================================== **/
      this._render();
      this.saveState();

      /** @Attach Events **/
      /** ========================================== **/

      this.wrapper.addEventListener('click', () => this.input.focus(), false);
      this.input.addEventListener('focus', () => this.wrapper.classList.add(this.options.mainWrapperFocusClass), false);
      this.input.addEventListener('blur', () => this.wrapper.classList.remove(this.options.mainWrapperFocusClass), false);

      this.input.addEventListener('keydown', this._onEnterPress.bind(this), false);
      this.options.button && this.button.addEventListener('click', this._onButtonClick.bind(this), false);

      this.tagsWrapper.addEventListener('click', this._delegatedTagRemove.bind(this), false);
    }

    _render() {
      const { input, button, wrapper, flexWrapper, tagsWrapper, options } = this;

      input.classList.add(options.inputClass);
      options.button && button.classList.add(options.buttonClass);
      wrapper.classList.add(options.mainWrapperClass);
      flexWrapper.classList.add(options.flexWrapperClass);
      tagsWrapper.classList.add(options.tagsWrapperClass);

      input.parentElement.insertBefore(wrapper, input);
      wrapper.append(flexWrapper);
      flexWrapper.append(tagsWrapper);
      flexWrapper.append(input);
      options.button && wrapper.append(button);

      this.tags.forEach(t => tagsWrapper.append(t.element));
    }

    _delegatedTagRemove(event) {
      const { target } = event;
      const match = target.nodeName.toLowerCase() === 'span' && target.classList.contains(this.options.tagCloseClass);

      if (!match) return;

      const { display } = target.parentElement.dataset;

      this.removeTag(display);
    }

    prefill() {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const value = unescape(params.get('q'));
      this.input.value = value;
    }

    _onEnterPress(event) {
      if (event.keyCode !== KEYS.ENTER) {
        return;
      }
      event.preventDefault();

      if (typeof this.options.callback === 'function') {
        this.options.callback(this);
      }
    }

    _onButtonClick(event) {
      event.preventDefault();

      if (typeof this.options.callback === 'function') {
        this.options.callback(this);
      }
    }

    addTag(options) {
      const tag = Tag.create(options);
      if (!this.tags.has(tag.display)) {
        this.tags.set(tag.display, tag);
        this.tagsWrapper.append(tag.element);
      }
    }

    removeTag(display) {
      if (!display) {
        throw new Error('Display name of the tag is required');
      }

      if (typeof display !== 'string') {
        throw new Error('Display name should be string');
      }

      if (this.tags.has(display)) {
        this.tags.get(display).element.remove();
        this.tags.delete(display);
        return true;
      }
      else {
        return false;
      }
    }

    removeAllTags() {
      this.tags.forEach(tag => this.removeTag(tag.display));
    }

    valueOf() {
      let tags = [];
      let value = this.input.value.trim();

      this.tags.forEach(t => tags.push(t.valueOf()));

      return { value, tags };

      /*
       * Do not use iterators for now
       */

      // return {
      //   value: this.input.value.trim(),
      //   tags: [...this.tags.values()].map(t => t.valueOf())
      // }
    }

    saveState() {
      const url = new URL(location.href);
      this._state.set(url.href, this.valueOf());
    }

    restoreState() {
      const url = new URL(location.href);

      if (!this._state.has(url.href)) {
        return;
      }

      const { tags } = this._state.get(url.href);

      this.removeAllTags();
      tags.forEach(tag => this.addTag(tag));
    }


    static create(input, options = defaults$2) {
      return new TagInput(input, options);
    }
  }

  const defaults$3 = {
    v2: { siteKey: '' },
    v3: { siteKey: '', action: 'search' },
    scriptSrc: 'https://www.google.com/recaptcha/api.js'
  };

  class Recaptcha {
    constructor(options) {
      const { v2, v3 } = options;

      if (v2 && !v2.siteKey) {
        throw new Error('[Recaptcha] "v2" site key is required');
      }

      if (v3) {
        if (!v3.siteKey) {
          throw new Error('[Recaptcha] "v3" site key is required');
        }
        if (!v3.action) {
          v3.action = defaults$3.v3.action;
        }
      }
      
      this.options = { ...defaults$3, ...options };

      this._script = null;
      this._scriptReady = false;
      this._scriptLoading = false;

      /** @var {Promise} - recaptcha script tag loaded promise */
      this._scriptLoaded = this._loadRecaptchaScript();

      /** Total time (in milliseconds) to wait for Recaptcha api to load (v2 only) */
      this._timeout = 3000;

      /** Interval time (in milliseconds) to test if Recaptcha api is loaded (v2 only) */
      this._delay = 0;
      this._retryDelay = 200;

      /** Init recaptcha v2 */
      this._recaptchaInit = this._recaptchaInit.bind(this);
      this._recaptchaRender = this._recaptchaRender.bind(this);
      this._recaptchaCallback = this._recaptchaCallback.bind(this);

      if (this.options.v2) {
        /** @var {Promise} - recaptcha v2 initialized promise */
        this._recaptchaInitialized = this._scriptLoaded.then(this._recaptchaInit);
      }
    }

    /*
     * @private
     * Load recaptcha javascript
     * Use only one script tag for "v2" and "v3"
     * Init automatically recaptcha "v3" if siteKey (v3) is provided
     */
    _loadRecaptchaScript() {
      const { scriptSrc } = this.options;
      const { siteKey } = this.options.v3;

      return new Promise((resolve, reject) => {
        if (this._scriptReady) {
          return grecaptcha.ready(resolve);
        }

        if (this._scriptLoading) {
          return reject(new Error('[Recaptcha] recaptcha script should be loaded only once'));
        }

        let script = document.createElement('script');

        script.defer = true;
        script.async = true;
        script.src = siteKey ? `${scriptSrc}?render=${siteKey}` : scriptSrc;
        script.id = `js-recaptcha-script-${Math.round(Math.random() * 10000)}-${Date.now()}`;

        script.addEventListener('load', (event) => {
          this._scriptReady = true;
          this._scriptLoading = false;
          return grecaptcha.ready(resolve);
        });

        script.addEventListener('error', (event) => {
          this._scriptReady = false;
          this._scriptLoading = false;
          return reject(new Error('[Recaptcha] script did not load'));
        });

        this._script = script;
        this._scriptLoading = true;

        document.body.append(script);
      });
    }

    /**
     * @private
     * This will render the widget when grecaptcha (v2) api is loaded
     * @return {Promise<String>} - Promise containing the id of the recaptcha rendered widget
     */
    _recaptchaInit() {
      return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
          // check if we can try again according to timeout
          if (this._delay < this._timeout) {
            this._delay += this._retryDelay;
            setTimeout(this._recaptchaInit, this._retryDelay);
          }
          else {
            reject(new Error('Recaptcha script timeout'));
          }
        }
        else {
          grecaptcha.ready(() => {
            this._recaptchaRender();
            resolve(this._recaptchaId);
          });
        }
      });
    }

    /**
     * @private
     * Render Recaptcha v2 widget
     */
    _recaptchaRender() {
      const { siteKey } = this.options.v2;

      const recaptchaId = grecaptcha.render(this._script.id, {
        sitekey: siteKey,
        size: 'invisible',
        callback: this._recaptchaCallback
      });

      this._recaptchaId = recaptchaId;
    }

    /**
     * @private
     * User provided callback for recaptcha v2
     */
    _recaptchaCallback(token) {
      grecaptcha.reset(this._recaptchaId);
      this._script.dispatchEvent(new CustomEvent('token', { detail: { token } }));
    }

    /**
     * @private
     * Get Recaptcha v2 token
     */
    _getV2Token() {
      return this._recaptchaInitialized.then(() => {
        const { siteKey } = this.options.v2;

        grecaptcha.execute(this._recaptchaId);

        return new Promise((resolve, reject) => {
          const onToken = (event) => {
            const { token } = event.detail;
            this._script.removeEventListener('token', onToken);
            resolve(token);
          };

          this._script.addEventListener('token', onToken);
        });
      });
    }

    /**
     * @private
     * Get Recaptcha v3 token
     */
    _getV3Token() {
      const { action, siteKey } = this.options.v3;
      return this._scriptLoaded.then(() => grecaptcha.execute(siteKey, { action }));
    }

    /**
     * @public
     * @param {String} version - 'v2' || 'v3'
     * @return {Promise<String>} - promise containing the token string
     */
    getToken(version) {
      if (version === 'v2') return this._getV2Token();
      if (version === 'v3') return this._getV3Token();
      return Promise.reject(new Error('Version "v2" or "v3" is required'));
    }
  }

  const SPAM_VALIDATION_ERROR = 'spam_validation';

  const defaults$4 = {
    recaptcha: {
      v2: false, // set object { siteKey: '' } to enable
      v3: false // set object { siteKey: '', action: '' } to enable
    },
    endpoint: '/search-v2/search/api',
    headers: {
      'accept': 'application/json',
      'content-type': 'application/json'
    },
    credentials: 'same-origin' // include cookies
  };

  class SearchApiService {
    constructor(options) {
      this.options = { ...defaults$4, ...options };

      const { v2, v3 } = this.options.recaptcha;

      if (v2 || v3) {
        this.recaptcha = new Recaptcha(this.options.recaptcha);
      }
    }

    /*
     * Do not use async/await for now
     */

    /**
     * @private
     */
    _fetch(payload) {
      const { endpoint, headers, credentials } = this.options;

      return fetch(endpoint, {
        method: 'POST',
        headers,
        credentials,
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (res.ok) {
          return res.json().then(d => this._validateRecaptchaResponse(d));
        }
        else if (res.status == 400)
        {
          return res.json().then(d => this._validateRecaptchaResponse(d)).then(() => { throw new Error(res.statusText); });
        }
        else {
          throw new Error(res.statusText);
        }
      });
    }

    /**
     * @public
     * @param {Object} payload
     */
    fetch(payload) {
      if (this.recaptcha) {
        const { v2, v3 } = this.recaptcha.options;

        // if both recaptcha v2 and v3 are enabled
        if (v2 && v3) {
          return this.recaptcha.getToken('v3')
            .then(token => this._fetch({ ...payload, recaptchaToken: token, recaptchaVersion: 'v3' }))
            .catch(e => {
              if (e && e.message === SPAM_VALIDATION_ERROR) {
                  return this.recaptcha.getToken('v2')
                    .then(token => this._fetch({ ...payload, recaptchaToken: token, recaptchaVersion: 'v2' }));
              }

              throw e;
            });
        }

        // if only recaptcha v2 is enabled
        if (v2) {
          return this.recaptcha.getToken('v2')
            .then(token => this._fetch({ ...payload, recaptchaToken: token, recaptchaVersion: 'v2' }));
        }

        // if only recaptcha v3 is enabled
        if (v3) {
          return this.recaptcha.getToken('v3')
            .then(token => this._fetch({ ...payload, recaptchaToken: token, recaptchaVersion: 'v3' }));
        }
      }

      return this._fetch(payload);
    }

    _validateRecaptchaResponse(data) {
      if (this._isRecaptchaError(data)) {
        throw new Error(SPAM_VALIDATION_ERROR);
      }

      return data;
    }

    _isRecaptchaError(data) {
      if (Array.isArray(data)) {
        const recaptchaValidationItem = data.filter(x => x.key === 'captchaValidation')[0];
        if (recaptchaValidationItem && recaptchaValidationItem.errors) {
          return true;
        }
      }
      else if (data && data.ModelState && data.ModelState.captchaValidation) {
        return true;
      }

      return false;
    }
  }

  class SearchUrlService {
    /*
     * Search results page URL
     * @example -> `` -> Default is empty string -> The input is placed on the same page as the search results. It will append query parameters to the current page url.
     * @example -> `search`  -> Relative child page path to the page where the input is placed -> www.example.com/page-with-tag-input/search.
     * @example -> `/search` -> Absolute page for the site -> www.example.com/search -> Will redirect to page with absolute url for the site.
     * @example -> `https://www.telerik.com/search` -> Other site, if the value starts with `http` or `https` it will redirect to another site
     */
    static generate({ uri = '', value = '', page = 0, tags = []}) {
      let url;
      const { origin, pathname } = window.location;

      if (!value) {
        throw new Error('Value should be provided');
      }

      if (typeof value !== 'string') {
        throw new Error('Value should be string');
      }

      if (value.length < 2) {
        throw new Error('Value should be minimum 2 characters')
      }

      // On the same page, only append query parameters to the current page
      if (uri === '') {
        url = new URL(`${origin}/${pathname}`);
      }

      // On child page relative to the current page
      if (!uri.startsWith('/')) {
        url = new URL(`${origin}/${pathname}/${uri}`);
      }

      // On absolute page for the same site
      if (uri.startsWith('/')) {
        url = new URL(`${origin}/${uri}`);
      }

      // On another website
      if (uri.startsWith('http')) {
        url = new URL(uri);
      }

      url.href = url.href.split('///').join('/').split('//').join('/').replace(':/', '://');

      url.searchParams.set('q', escape(value));

      tags.forEach(t => url.searchParams.append(t.key, t.value));

      // Set paging
      if (page > 0) {
        url.searchParams.set('page', page);
      }

      url.searchParams.sort();

      return url;
    }

    static parse(url = location.href) {
      const _url = new URL(url);
      const params = _url.searchParams;

      const result = {
        q: unescape(params.get('q')),
        filter: params.getAll('filter'),
        context: params.getAll('context'),
        page: Number(params.get('page')) || 1
      };

      return result;
    }

    static validate(url) {
      let result = false;

      try {
        new URL(url);
        result = true;
      }
      catch (error) {
        result = false;
      }

      return result;
    }

    static redirect(url) {
      if (!SearchUrlService.validate(url)) {
        throw new Error('Please provide valid URL');
      }

      window.location.href = url;
    }

    static push(url) {
      if (!SearchUrlService.validate(url)) {
        throw new Error('Please provide valid URL');
      }

      window.history.pushState(null, null, url.search);
    }

    static replace(url) {
      if (!SearchUrlService.validate(url)) {
        throw new Error('Please provide valid URL');
      }

      window.history.replaceState(null, null, url.search);
    }
  }

  const defaults$5 = {
    wrapperClass: 'TK-Search-Results-Spellcheck-Wrapper',
    didYouMeanText: 'Did you mean: {0}',
  };

  class SpellCheck {
    constructor(element, options) {
      if (!(element instanceof HTMLElement)) {
        throw new Error('[SpellCheck] DOM element is required for initialization');
      }

      this._spellCheckCorrectionWord = '';

      this.options = { ...defaults$5, ...options };

      this.wrapper = element;
      this.wrapper.classList.add(this.options.wrapperClass);

      this.container = document.createElement('div');
      this.render = this.render.bind(this);
      this.hide = this.hide.bind(this);
    }

    render(settings) {
      let newUrl = '';

      if (settings.redirect) {
        newUrl = SearchUrlService.generate({ value: this._spellCheckCorrectionWord, tags: settings.tags, page: 1, uri: settings.redirectUri });
      }
      else {
        newUrl = SearchUrlService.generate({ value: this._spellCheckCorrectionWord, tags: settings.tags, page: 1 });
      }
      
      const didYouMeanLabel = this.options.didYouMeanText.replace('{0}', `<a href="${newUrl}">${escape(this._spellCheckCorrectionWord)}</a>`);
      this.container.innerHTML = `<span>${didYouMeanLabel} </span>`;
      this.wrapper.innerHTML = '';
      this.wrapper.removeAttribute('hidden');
      this.wrapper.append(this.container);
    }

    hide() {
      this.wrapper.setAttribute('hidden', true); 
    }

    setSpellCheckCorrectionWord(spellCheckCorrectionWord) {
      this._spellCheckCorrectionWord = spellCheckCorrectionWord;
      return this;
    }

    static create(element, options = defaults$5) {
      return new SpellCheck(element, options);
    }
  }

  const defaults$6 = {
    url: false,
    text: false,
    hashtag: false,
    popupWidth: 580,
    popupHeight: 400,
    wrapperClass: 'TK-Search-Social-Share',
    navClass: 'TK-Search-Social-Share-Nav',
    buttonClass: 'TK-Search-Social-Share-Button',
    buttonText: 'Share',
    networks: ['twitter', 'facebook', 'linkedin', 'reddit']
  };

  class SocialShare {
    static html(options) {
      const opts = { ...defaults$6, ...options };
      const { url, text, wrapperClass, navClass, buttonText, buttonClass, networks } = opts;

      const links = networks.map(media => {
        return `<a href="${SocialShare.generateMediaURL({url, media, text})}" class="icon-${media}-full" data-media="${media}" data-url="${url}"></a>`;
      }).join('');

      const html = `
      <aside class="${wrapperClass}">
        <div class="${navClass}">${links}</div>
        <button type="button" class="${buttonClass}" data-share-toggle>${buttonText}</button>
      </aside>
    `;

      return html;
    }

    static generateMediaURL({ media, url, text }) {
      let result = '';
      const _url = encodeURIComponent(url);
      const _text = encodeURIComponent(strip(text));

      switch (media) {
        case 'facebook':
          result = `http://www.facebook.com/sharer.php?u=${_url}`;
          break;
        case 'linkedin':
          result = `https://www.linkedin.com/shareArticle?mini=true&url=${_url}&summary=${_text}`;
          break;
        case 'reddit':
          result = `https://www.reddit.com/login?redirect=https://www.reddit.com/submit?url=${_url}`;
          break;
        case 'twitter':
        default:
          result = `https://twitter.com/share?url=${_url}&text=${_text}`;
          break;
      }

      return result;
    }

    static _delegatedToggleShare(event) {
      const { target } = event;
      const match = target.nodeName.toLowerCase() === 'button' && target.className === defaults$6.buttonClass;

      if (!match) {
        return;
      }

      target.previousSibling.classList.toggle('is-visible');

      event.preventDefault();
      event.stopPropagation();
    }

    static _delegatedOpenMediaPopup(event) {
      const { target } = event;
      const match = target.nodeName.toLowerCase() === 'a' && Boolean(target.dataset.media);

      if (!match) {
        return;
      }

      const { popupWidth, popupHeight } = defaults$6;

      const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      const top = (h - popupHeight) / 2;
      const left = (w - popupWidth) / 2;

      const options = `status=1,width=${popupWidth},height=${popupHeight},top=${top},left=${left}`;

      event.preventDefault();
      event.stopPropagation();

      window.open(target.href, 'Share', options);
    }
  }

  const defaults$7 = {
    socialShare: false,
    socialShareButtonText: '',
    wrapperClass: 'TK-Search-Results-List-Wrapper',
    noResultsClass: 'TK-Search-Results-Zero',
    errorResultsClass: 'TK-Search-Results-Error',
    searchQueryClass: 'TK-Search-Results-Query',
    listClass: 'TK-Search-Results-List',
    listItemClass: 'TK-Search-Results-List-Item',
    itemHeadingClass: 'TK-Search-Results-List-Item-H',
    itemDescriptionClass: 'TK-Search-Results-List-Item-P',
    itemLastLinkClass: 'TK-Search-Results-List-Item-A',
    tryMoreGeneralText: 'Try more general keywords.',
    tryDiffKeywordText: 'Try different keywords.',
    goBackText: 'Go back',
    allWordsSpelledCorrectText: 'Make sure all words are spelled correctly.',
    searchDidNotMatchText: `Your search "{0}" did not match any documents. Search suggestions:`,
    somethingsNotRightText: "Oh, no! Something's not right, but we're sorting it out."
  };

  class SearchResultsList {
    constructor(element, options) {
      if (!(element instanceof HTMLElement)) {
        throw new Error('[SearchResultsList] DOM element is required for initialization');
      }

      this.options = { ...defaults$7, ...options };

      this.wrapper = element;
      this.wrapper.classList.add(this.options.wrapperClass);

      this.list = document.createElement('ul');
      this.list.classList.add(this.options.listClass);
      this.list.addEventListener('click', this._resultClickHandler.bind(this), false);

      if (this.options.socialShare) {
        this.socialShare = true;
        this.wrapper.addEventListener('click', SocialShare._delegatedToggleShare);
        this.wrapper.addEventListener('click', SocialShare._delegatedOpenMediaPopup);
      }

      this.render = this.render.bind(this);
      this._itemHTML = this._itemHTML.bind(this);
    }

    empty() {
      this.list.innerHTML = '';
      this.wrapper.innerHTML = '';
    }

    render(options) {
      const { results, query } = options;

      if (options instanceof Error) {
        this.wrapper.innerHTML = this._errorResultsHTML();
        return;
      }

      if (!results) {
        throw new Error('[SearchResultsList] "options.results" is required');
      }

      if (!Array.isArray(results)) {
        throw new Error('[SearchResultsList] "options.results" should be array');
      }

      const html = results.map(this._itemHTML).join('');

      this.list.innerHTML = '';
      this.wrapper.innerHTML = '';

      if (results.length) {
        this.list.innerHTML = html;
        this.wrapper.append(this.list);
      }
      else {
        this.wrapper.innerHTML = this._noResultsHTML({ query });
      }
    }

    _itemHTML(options) {
      const { title, description, url } = options;
      const { listItemClass, itemHeadingClass, itemDescriptionClass, itemLastLinkClass, socialShareButtonText } = this.options;
      const socialShareHTML = this.socialShare && SocialShare.html({ url, text: title, buttonText: socialShareButtonText }) || '';

      const html = `
      <li class="${listItemClass}">
        <h4 class="${itemHeadingClass}"><a href="${url}">${title}</a></h4>
        <p class="${itemDescriptionClass}">${description}</p>
        <div class="u-cf -cf">
          <a class="${itemLastLinkClass}" href="${url}">${url}</a>
          ${socialShareHTML}
        </div>
      </li>
    `;

      const result = html.trim().split('\n').map(x => x.trim()).join('');

      return result;
    }

    _noResultsHTML(options) {
      const { query } = options;
      const { noResultsClass, searchQueryClass, tryMoreGeneralText, allWordsSpelledCorrectText, tryDiffKeywordText, goBackText } = this.options;
      const searchDidNotMatchLabel = this.options.searchDidNotMatchText.replace('{0}', `<b class="${searchQueryClass}">${escape(query)}</b>`);

      const html = `
      <div class="${noResultsClass}">
        <p>${searchDidNotMatchLabel}</p>
        <ul>
          <li>${allWordsSpelledCorrectText}</li>
          <li>${tryDiffKeywordText}</li>
          <li>${tryMoreGeneralText}</li>
        </ul>
        <hr>
        <a href="javascript:history.back()">${goBackText}</a>
      </div>
    `;

      const result = html.trim().split('\n').map(x => x.trim()).join('');

      return result;
    }

    _errorResultsHTML() {
      const { errorResultsClass, somethingsNotRightText, allWordsSpelledCorrectText, tryDiffKeywordText, tryMoreGeneralText, goBackText } = this.options;

      const html = `
      <div class="${errorResultsClass}">
        <p>${somethingsNotRightText}</p>
        <ul>
          <li>${allWordsSpelledCorrectText}</li>
       <li>${tryDiffKeywordText}</li>
          <li>${tryMoreGeneralText}</li>
        </ul>
        <hr>
        <a href="javascript:history.back()">${goBackText}</a>
      </div>
    `;

      const result = html.trim().split('\n').map(x => x.trim()).join('');

      return result;
    }

    _resultClickHandler(event) {
      const target = event.target;
      if (target.nodeName.toLowerCase() !== 'a') {
        return;
      }

      const eventData = {
        text: target.innerText,
        url: target.href
      };

      this.wrapper.dispatchEvent(new CustomEvent('search-result-open', { detail: eventData }));
    }
  }

  const defaults$8 = {
    wrapperClass: 'TK-Search-Results-Count-Wrapper',
    searchQueryClass: 'TK-Search-Results-Query',
    maxPageSize: 10,
    resultForCurrentSearchText: `{0}-{1} of {2} results for "{3}"`
  };

  class SearchResultsCount {
    constructor(element, options) {
      if (!(element instanceof HTMLElement)) {
        throw new Error('[SearchResultsCount] DOM element is required for initialization');
      }

      this._totalResultsCount = 0;
      this._pageSize = 0;
      this._searchQuery = '';

      this.options = { ...defaults$8, ...options };

      this.wrapper = element;
      this.wrapper.classList.add(this.options.wrapperClass);

      this.container = document.createElement('div');
      this.render = this.render.bind(this);
    }

    empty() {
      this.wrapper.innerHTML = '';
    }

    render(page) {
      this.container.innerHTML = this._generateInnerHtml(page);

      this.wrapper.innerHTML = '';

      if (this._totalResultsCount > 0) {
        this.wrapper.append(this.container);
      }
    }

    setTotalResultsCount(totalResultsCount) {
      this._totalResultsCount = totalResultsCount;
      return this;
    }

    setPageSize(pageSize) {
      if (pageSize > this.options.maxPageSize) {
        this._pageSize = this.options.maxPageSize;
      }

      this._pageSize = pageSize;
      return this;
    }

    setSearchQuery(searchQuery) {
      const encodedSearchQuery = escape(searchQuery);
      this._searchQuery = encodedSearchQuery;
      return this;
    }

    _calcRange(page) {
      let leftPart = -1;
      let rightPart = -1;

      if (this._totalResultsCount < this.options.maxPageSize) {
        leftPart = 1;
        rightPart = this._totalResultsCount;
      }
      else {
        leftPart = (page - 1) * this._pageSize + 1;
        rightPart = page * this._pageSize;
      }

      return {
        leftPart: leftPart,
        rightPart: rightPart
      };
    }

    _generateInnerHtml(page) {
      let html = '';

      if (this._totalResultsCount > 0) {
        let range = this._calcRange(page);

        const resultsCountLabel = this.options.resultForCurrentSearchText
        .replace("{0}", range.leftPart)
        .replace("{1}", range.rightPart)
        .replace("{2}", this._totalResultsCount)
        .replace("{3}", `<b class="${this.options.searchQueryClass}">${this._searchQuery}</b>`);

        html = resultsCountLabel;
      }

      return html;
    }

    static create(element, options = defaults$8) {
      return new SearchResultsCount(element, options);
    }
  }

  window.dataLayer = window.dataLayer || [];

  class TrackingEvent {
    constructor(name) {
      this.name = name;
      this.category = null;
      this.action = null;
      this.label = null;
    }

    valueOf() {
      const eventObject = {
        'event': this.name,
        'eventCategory': this.category,
        'eventAction': this.action
      };

      if (this.label) {
        eventObject.eventLabel = this.label;
      }

      return eventObject;
    }
  }

  class SearchEventBase extends TrackingEvent {
    constructor(category) {
      super('search');
      this.category = category;
    }

    stringifyTags(tags) {
      if (!tags || tags.length === 0) {
        return '';
      }

      const tagsString = tags.map(t => `${t.key}: ${t.display}`).join();

      return tagsString;
    }
  }

  class SearchEvent extends SearchEventBase {
    constructor(tags, query) {
      super('website-search-terms');

      this.action = this.stringifyTags(tags);
      this.label = query;
    }
  }

  class SearchResultEvent extends SearchEventBase {
    constructor(tags, query, result) {
      super('website-search-result');

      this.action = query;

      const serializedTags = this.stringifyTags(tags);
      if (serializedTags) {
        this.action = `${serializedTags} - ${this.action}`;
      }

      this.label = result;
    }
  }

  class EventTracker {
    constructor() {
      this._dataLayer = window.dataLayer;
    }

    track(event) {
      if (!event) {
        return;
      }

      var eventObject = event.valueOf();

      this._dataLayer.push(eventObject);
    }
  }

  document.createElement('tk-site-search');

  const defaults$9 = {
    endpoint: '/webapi/search/do' // c# backend api
  };

  const scrollingTypes = ['auto', 'instant', 'smooth'];

  class SiteSearchElement {
    constructor(element, options) {
      if (!(element instanceof HTMLElement)) {
        throw new Error('[SiteSearchElement] DOM element is required for initialization');
      }

      this.element = element;
      this.element.dataset.version = '3.9.4';
      this.container = document.querySelector(element.dataset.containerSelector) || this.element; // Where to append additional elements (results, pager, etc...)

      let dataset = Parser.parse(element.dataset, ['list', 'pager', 'tag-input', 'recaptcha-v2', 'recaptcha-v3', 'spellcheck']);

      if (!Array.isArray(dataset.tagInput.tags)) {
        dataset.tagInput.tags = [];
      }

      this.options = { ...defaults$9, ...dataset, ...options };

      if (this.options.scrollIntoView) {
        if (scrollingTypes.indexOf(this.options.scrollIntoViewBehavior) === -1) {
          this.options.scrollIntoViewBehavior = scrollingTypes[0];
        }
      }

      this.input = document.createElement('input');
      this.input.type = 'search';
      this.element.append(this.input);

      this.tagInput = new TagInput(this.input, {
        ...this.options.tagInput,
        callback: (tagInput) => this._onSearch(tagInput)
      });

      if (this.options.hasCount) {
        this.resultsCountWrapper = document.createElement('div');
        this.container.append(this.resultsCountWrapper);
        this.resultsCount = new SearchResultsCount(this.resultsCountWrapper, this.options.list);
      }

      if (this.options.hasSpellcheck) {
        this.spellCheckWrapper = document.createElement('div');
        this.container.append(this.spellCheckWrapper);
        this.spellcheck = new SpellCheck(this.spellCheckWrapper, this.options.spellcheck);
      }

      if (this.options.hasList) {
        this.listWrapper = document.createElement('div');
        this.container.append(this.listWrapper);
        this.list = new SearchResultsList(this.listWrapper, this.options.list);
        this.listWrapper.addEventListener('search-result-open', this._onSearchResultOpen.bind(this), false);
      }

      if (this.options.hasPager) {
        this.pagerWrapper = document.createElement('div');
        this.container.append(this.pagerWrapper);
        this.pager = new Pager(this.pagerWrapper, {
          ...this.options.pager,
          callback: (pager, page) => this._onPageChanged(pager, page)
        });
      }

      const recaptchaOptions = {
        v2: this.options.hasRecaptchaV2 ? this.options.recaptchaV2 : false,
        v3: this.options.hasRecaptchaV3 ? this.options.recaptchaV3 : false
      };

      if (this.options.recaptchaScriptSrc) {
        recaptchaOptions.scriptSrc = this.options.recaptchaScriptSrc;
      }
      
      this.api = new SearchApiService({
        endpoint: this.options.endpoint,
        recaptcha: recaptchaOptions
      });

      if (this.list && this.pager) {
        this.tagInput.saveState();
        history.scrollRestoration = 'manual';
        window.addEventListener('popstate', (event) => this._onPopState(event));
      }

      this.eventTracker = new EventTracker();

      this._onInitialRender();
    }

    /*
     * Executed on initial render, on popstate event and on page changed
     */
    _onInitialRender() {
      const payloadFromURL = SearchUrlService.parse(location.href);
      const { q, page } = payloadFromURL;

      if (!q) {
        this._empty();
        return;
      }

      this.list && this.pager && this.api
        .fetch(payloadFromURL)
        .then(data => this._onOkApiFetch(data, page))
        .catch(error => this._onFailApiFetch(error))
        .finally(() => this._scrollIntoView());
    }

    /*
     * @param `widget` is TagInput or Pager instance
     * @param `page` is selected page if widget is instace of Pager
     * Executed on user interaction with TagInput or Pager
     */
    _onSearch(tagInput) {
      const { redirect, redirectUri } = this.options;
      const { value, tags } = this.tagInput.valueOf();

      if (value.length < 2) {
        console.warn('[SiteSearchElement] # _onSearch => TagInput value should be at least 2 characters => Early Exit');
        return;
      }

      this.eventTracker.track(new SearchEvent(tags, value));

      if (redirect) {
        SearchUrlService.redirect(SearchUrlService.generate({ value, tags, uri: redirectUri }));
        return;
      }

      const payload = {
        // page: 1,
        q: value,
        filter: tags.filter(t => t.key === 'filter').map(t => t.value),
        context: tags.filter(t => t.key === 'context').map(t => t.value)
      };

      SearchUrlService.push(SearchUrlService.generate({ value, tags }));

      this.tagInput.saveState();

      this.list && this.pager && this.api
        .fetch(payload)
        .then(data => this._onOkApiFetch(data, 1))
        .catch(error => this._onFailApiFetch(error))
        .finally(() => this._scrollIntoView());
    }

    _onPageChanged(pager, page = 1) {
      let url = new URL(location.href);
      url.searchParams.set('page', page);
      SearchUrlService.push(url);
      this.tagInput.prefill();
      this.tagInput.saveState();
      this._onInitialRender();
    }

    _onOkApiFetch(data, page) {
      const query = data.SearchQuery;
      const pageSize = data.PageSize;
      const totalResults = data.TotalResults;
      const spellCheckPhrase = data.SpellCheckPhrase;

      if (Array.isArray(data)) {
        if (data[0].errors) {
          throw new Error(data[0].errors[0]);
        }
      }

      const results = data.SearchResultData.map(x => ({
        url: x.Url,
        title: x.Title,
        description: x.Summary,
        query: data.SearchQuery
      }));

      if (this.resultsCount) {
        this.resultsCount
          .setPageSize(pageSize)
          .setTotalResultsCount(totalResults)
          .setSearchQuery(query)
          .render(page);
      }

      if (this.spellcheck) {
        if (spellCheckPhrase && page === 1) {
          const { tags } = this.tagInput.valueOf();
          const { redirect, redirectUri } = this.options;

          this.spellcheck
            .setSpellCheckCorrectionWord(spellCheckPhrase)
            .render({ redirect, redirectUri, tags });
        }
        else {
          this.spellcheck.hide();
        }
      }

      if (this.list) {
        this.list.render({ results, query });
      }

      if (this.pager) {
        if (totalResults <= pageSize) {
          this.pager.empty();
        }
        else {
          this.pager
            .setPageSize(pageSize)
            .setTotalItems(totalResults)
            .setPage(page)
            .render();
        }
      }

      this.element.dispatchEvent(new CustomEvent('search', { detail: { query, pageSize, totalResults, spellCheckPhrase, results } }));
    }

    _onFailApiFetch(error) {
      if (this.list) {
        this.list.render(error);
      }

      this.element.dispatchEvent(new CustomEvent('error', { detail: { error } }));
    }

    _onPopState(event) {
      this.tagInput.prefill();
      this.tagInput.restoreState();
      this._onInitialRender();
    }

    _scrollIntoView() {
      const { scrollIntoView, scrollIntoViewBehavior } = this.options;

      if (scrollIntoView) {
        this.element.parentElement.scrollIntoView({ behavior: scrollIntoViewBehavior, block: 'start' });
      }
    }

    _empty() {
      this.resultsCount && this.resultsCount.empty();
      this.spellcheck && this.spellcheck.hide();
      this.list && this.list.empty();
      this.pager && this.pager.empty();
    }

    _onSearchResultOpen(event) {
      const { value, tags } = this.tagInput.valueOf();
      this.eventTracker.track(new SearchResultEvent(tags, value, event.detail.url));
    }
  }

  /*
   * Attached to window with rollup iife
   *
   * window.biz.Pager
   * window.biz.TagInput
   * window.biz.Recaptcha
   * window.biz.SiteSearchElement
   * window.biz.SearchApiService
   * window.biz.SearchUrlService
   */

  exports.Pager = Pager;
  exports.TagInput = TagInput;
  exports.Recaptcha = Recaptcha;
  exports.SearchApiService = SearchApiService;
  exports.SearchUrlService = SearchUrlService;
  exports.SiteSearchElement = SiteSearchElement;

}((this.biz = this.biz || {})));
//# sourceMappingURL=index.es6.js.map
